import axios from "axios";
import { IP } from "../index";
// 查询所有订单
export async function selectallorder(data) {
  var resp = await axios.post(`${IP}/admin/niaojianResult/selectAll`, { ...data });
  return resp.data;
}

// 删除订单
export async function deleteOrder(id) {
  var resp = await axios.post(`${IP}/admin/niaojianResult/deleteById`, {
    id,
  });
  return resp.data;
}
